import React from 'react';
import { Clipboard } from 'react-feather';

function Select({ Component = Clipboard, onClick }) {
  return (
    <div onClick={onClick} style={{ cursor: 'pointer' }}>
      <Component />
    </div>
  );
}

export default Select;
